/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TargetVsActualRow
 */
export interface TargetVsActualRow {
    /**
     * 
     * @type {string}
     * @memberof TargetVsActualRow
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof TargetVsActualRow
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof TargetVsActualRow
     */
    targetMaturity?: number;
    /**
     * 
     * @type {number}
     * @memberof TargetVsActualRow
     */
    currentComposite?: number;
    /**
     * 
     * @type {number}
     * @memberof TargetVsActualRow
     */
    currentOperational?: number;
    /**
     * 
     * @type {number}
     * @memberof TargetVsActualRow
     */
    gapToTarget?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TargetVsActualRow
     */
    onTrack?: boolean;
}

/**
 * Check if a given object implements the TargetVsActualRow interface.
 */
export function instanceOfTargetVsActualRow(value: object): value is TargetVsActualRow {
    return true;
}

export function TargetVsActualRowFromJSON(json: any): TargetVsActualRow {
    return TargetVsActualRowFromJSONTyped(json, false);
}

export function TargetVsActualRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): TargetVsActualRow {
    if (json == null) {
        return json;
    }
    return {
        
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'targetMaturity': json['targetMaturity'] == null ? undefined : json['targetMaturity'],
        'currentComposite': json['currentComposite'] == null ? undefined : json['currentComposite'],
        'currentOperational': json['currentOperational'] == null ? undefined : json['currentOperational'],
        'gapToTarget': json['gapToTarget'] == null ? undefined : json['gapToTarget'],
        'onTrack': json['onTrack'] == null ? undefined : json['onTrack'],
    };
}

export function TargetVsActualRowToJSON(json: any): TargetVsActualRow {
    return TargetVsActualRowToJSONTyped(json, false);
}

export function TargetVsActualRowToJSONTyped(value?: TargetVsActualRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initiativeId': value['initiativeId'],
        'name': value['name'],
        'targetMaturity': value['targetMaturity'],
        'currentComposite': value['currentComposite'],
        'currentOperational': value['currentOperational'],
        'gapToTarget': value['gapToTarget'],
        'onTrack': value['onTrack'],
    };
}

